module.exports = __webpack_public_path__ + "img/edge1-min.jpg";